import React, {PureComponent, ReactNode} from 'react';
import SmartLoader from 'app/components/reusable/SmartLoader';

export default class SmartPageLoader extends PureComponent {
    render(): ReactNode {
        return <SmartLoader loaderClassName="smart-loader-page"/>;
    }
}
